import React from "react";
import ContactUs from "../../Components/Contact/ContactUs";
import AuctionList from "../../Components/AuctionList/AuctionList";

const Contacts = () => {
  return (
    <div style={{ overflow: "hidden" }}>
      <ContactUs />
    </div>
  );
};

export default Contacts;
